import { gql } from '@apollo/client'

export const getInvoiceByDocumentLinkQuery = gql`
  query getInvoiceByDocumentLink($filter: JSON!) {
    getInvoiceByDocumentLink(filter: $filter) {
      _id
      code
      status
      createdAt
      paymentStatus
      payments {
        _id
        status
      }
      billingAddress {
        _id
        fullAddress
      }
      shippingAddress {
        _id
        fullAddress
      }
      gross
      shippingFee
      taxAmount
      discount
      net
      items {
        _id
        quantity
        price
        net
        remarks
        uom {
          _id
          name
        }
        product {
          _id
          code
          name
          coverImage
          coverImageThumb
        }
      }
    }
  }
`
